import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FeatureFlagService } from 'src/app/core/services/feature-flag.service';
import { EFeatureFlag } from 'src/app/core/services/feature-flags-consts';
import { EUserRole } from '../../../../../share/share-utils/user-roles';
import { TShare } from '../../../../../share/share.model';
import { EditAccountUserModalDataService } from '../../edit-account-user-modal-data.service';
import { PrepareShareService } from './prepare-share.service';

@Component({
  selector: 'pp-account-user-modal-shares-list-share',
  templateUrl: './account-user-modal-shares-list-share.component.html',
  styleUrls: ['./account-user-modal-shares-list-share.component.scss'],
  standalone: false,
})
export class AccountUserModalSharesListShareComponent implements OnInit {
  @Input() ppWorkspaceId: string;
  @Input() ppHasError: boolean;
  @Output() ppShowCustomFieldsTable = new EventEmitter<void>();

  share: TShare;
  EUserRole = EUserRole;
  relatedPointsFlagEnabled: boolean;

  private readonly disabledForAdminRoles: EUserRole[] = [
    EUserRole.SITE_ADMIN,
    EUserRole.ACCOUNT_ADMIN,
  ];

  private readonly disabledForAdminAndLimitedRoles: EUserRole[] = [
    EUserRole.SITE_ADMIN,
    EUserRole.ACCOUNT_ADMIN,
    EUserRole.LIMITED,
  ];

  private readonly disabledForAdminAndOwnerRoles: EUserRole[] = [
    EUserRole.SITE_ADMIN,
    EUserRole.ACCOUNT_ADMIN,
    EUserRole.OWNER,
  ];

  get isDisabledForAdmin(): boolean {
    return this.disabledForAdminRoles.includes(this.share?.shareOption);
  }

  get isDisabledForAdminAndLimited(): boolean {
    return this.disabledForAdminAndLimitedRoles.includes(this.share?.shareOption);
  }

  get isDisabledForAdminAndOwner(): boolean {
    return this.disabledForAdminAndOwnerRoles.includes(this.share?.shareOption);
  }

  constructor(
    private prepareShareService: PrepareShareService,
    private editAccountUserModalDataService: EditAccountUserModalDataService,
    private featureFlagService: FeatureFlagService,
  ) {
    this.editAccountUserModalDataService.sharesBulkChange$.subscribe(() => {
      this.share = this.editAccountUserModalDataService.getShare(this.ppWorkspaceId);
    });

    this.relatedPointsFlagEnabled = this.featureFlagService.getFlag(EFeatureFlag.RELATED_POINTS);

    this.featureFlagService.flagsChange$.subscribe(() => {
      this.relatedPointsFlagEnabled = this.featureFlagService.getFlag(EFeatureFlag.RELATED_POINTS);
    });
  }

  ngOnInit(): void {
    this.share = this.prepareShareService.prepareShare(this.ppWorkspaceId);
    this.editAccountUserModalDataService.setShare(this.ppWorkspaceId, this.share);
  }

  showCustomFieldsTable(): void {
    this.ppShowCustomFieldsTable.emit();
  }

  updateShare(emit: boolean = true): void {
    this.editAccountUserModalDataService.setShare(this.ppWorkspaceId, this.share);

    if (emit) {
      this.editAccountUserModalDataService.emitSharesChange();
    }
  }
}
